function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import './CheckboxesInput.css';
import whitelistProps from '../../utils/whitelistProps';
import noop from '../../utils/noop';
import cs from 'classnames';
import Fieldset from '../Fieldset/Fieldset';
import FormLabel from '../FormLabel/FormLabel';
import withInputContainer from '../withInputContainer/withInputContainer';
import { CheckboxInput } from '../CheckboxInput/CheckboxInput';
import ThemeContext from '../../ThemeContext/ThemeContext';
var whitelist = whitelistProps();
export var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inherits(Checkbox, _React$Component);
  function Checkbox() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Checkbox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.handleChange = function () {
      var _this$props = _this.props,
        checked = _this$props.checked,
        onChange = _this$props.onChange,
        option = _this$props.option;
      onChange(!checked, option);
    };
    return _this;
  }
  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        checked = _this$props2.checked,
        disabled = _this$props2.disabled,
        iconIds = _this$props2.iconIds,
        errorId = _this$props2.errorId,
        errorMsg = _this$props2.errorMsg,
        id = _this$props2.id,
        name = _this$props2.name,
        onBlur = _this$props2.onBlur,
        onFocus = _this$props2.onFocus,
        option = _this$props2.option,
        readonly = _this$props2.readonly,
        required = _this$props2.required,
        size = _this$props2.size,
        style = _this$props2.style,
        _this$props2$type = _this$props2.type,
        type = _this$props2$type === void 0 ? 'checkbox' : _this$props2$type,
        width = _this$props2.width,
        view = _this$props2.view,
        attrs = _objectWithoutProperties(_this$props2, ["checked", "disabled", "iconIds", "errorId", "errorMsg", "id", "name", "onBlur", "onFocus", "option", "readonly", "required", "size", "style", "type", "width", "view"]);
      var styl = width ? Object.assign({}, style, {
        width: width
      }) : style;
      var theme = this.context;
      return /*#__PURE__*/React.createElement("span", {
        className: cs('_dm-checkboxes__option', "_dm-checkboxes__option--".concat(size), "auto-checkbox-option-".concat(id))
      }, view === 'PRINT' ? /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: option.label
        }
      }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckboxInput, Object.assign({
        "aria-describedby": "".concat(iconIds, " ").concat(errorId),
        "aria-disabled": disabled,
        "aria-errormessage": errorId,
        "aria-invalid": !!errorMsg,
        "aria-readonly": readonly,
        "aria-required": !!required,
        checked: checked,
        disabled: disabled,
        id: id,
        name: name,
        onBlur: onBlur,
        onFocus: onFocus,
        readOnly: readonly,
        required: required,
        style: styl,
        type: type,
        onChange: readonly ? noop : this.handleChange
      }, whitelist(attrs))), /*#__PURE__*/React.createElement(FormLabel, {
        htmlFor: id,
        i18n: option.label,
        metaType: "boolean",
        size: "small",
        type: "checkbox",
        theme: theme
      })));
    }
  }]);
  return Checkbox;
}(React.Component);
Checkbox.contextType = ThemeContext;
export var CheckboxesInput = /*#__PURE__*/function (_React$Component2) {
  _inherits(CheckboxesInput, _React$Component2);
  function CheckboxesInput() {
    var _getPrototypeOf3;
    var _this2;
    _classCallCheck(this, CheckboxesInput);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(CheckboxesInput)).call.apply(_getPrototypeOf3, [this].concat(args)));
    _this2.handleChange = function (checked, option) {
      var _this2$props = _this2.props,
        onChange = _this2$props.onChange,
        options = _this2$props.options,
        _this2$props$value = _this2$props.value,
        value = _this2$props$value === void 0 ? [] : _this2$props$value;
      var newValue;
      if (checked) {
        var optionIndex = {};
        options.forEach(function (option, index) {
          optionIndex[option.value] = index;
        });
        newValue = value.slice();
        newValue.push(option.value);
        newValue.sort(function (a, b) {
          return optionIndex[a] - optionIndex[b];
        });
      } else {
        newValue = value.filter(function (value) {
          return value !== option.value;
        });
      }
      onChange(newValue);
    };
    return _this2;
  }
  _createClass(CheckboxesInput, [{
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props3 = this.props,
        options = _this$props3.options,
        auto = _this$props3.auto,
        _this$props3$size = _this$props3.size,
        size = _this$props3$size === void 0 ? 'small' : _this$props3$size,
        _this$props3$scroll = _this$props3.scroll,
        scroll = _this$props3$scroll === void 0 ? false : _this$props3$scroll,
        _this$props3$scrollHe = _this$props3.scrollHeight,
        scrollHeight = _this$props3$scrollHe === void 0 ? '150px' : _this$props3$scrollHe,
        id = _this$props3.id,
        disabled = _this$props3.disabled,
        readonly = _this$props3.readonly,
        _this$props3$value = _this$props3.value,
        value = _this$props3$value === void 0 ? [] : _this$props3$value,
        attrs = _objectWithoutProperties(_this$props3, ["options", "auto", "size", "scroll", "scrollHeight", "id", "disabled", "readonly", "value"]);
      var index = value.reduce(function (acc, val) {
        acc[val] = true;
        return acc;
      }, {});
      var _scroll = this.props.formContext && this.props.formContext.isPrintView ? false : scroll;
      var style = _scroll ? {
        height: scrollHeight
      } : null;
      var _options = this.props.formContext && this.props.formContext.isPrintView ? options.filter(function (option) {
        return value.includes(option.value);
      }) : options;
      return /*#__PURE__*/React.createElement("div", {
        className: cs('_dm-checkboxes__options', "_dm-checkboxes__options--".concat(size), "_dm-checkboxes__options--".concat(id), {
          '_dm-checkboxes__options--scroll': _scroll
        }, "auto-checkboxes auto-checkboxes-".concat(id), _defineProperty({}, auto, auto)),
        style: style
      }, _options.map(function (option) {
        var key = "".concat(id, "-").concat(option.value);
        return /*#__PURE__*/React.createElement(Checkbox, Object.assign({}, attrs, {
          disabled: !!disabled || !!option.disabled,
          readonly: !!readonly || !!option.readonly,
          checked: !!index[option.value],
          id: key,
          key: key,
          onChange: _this3.handleChange,
          option: option,
          size: size,
          name: id,
          view: _this3.props.formContext ? _this3.props.formContext.view : null
        }));
      }));
    }
  }]);
  return CheckboxesInput;
}(React.Component);
export default withInputContainer({
  type: 'checkboxes',
  element: Fieldset
})(CheckboxesInput);